// extracted by mini-css-extract-plugin
export default {"actionButtonsContainer":"DocumentSearch_actionButtonsContainer__e9Kwe","documentSearchLeftRegistryContainer":"DocumentSearch_documentSearchLeftRegistryContainer__ZAVNs"};